import React from 'react'
import "./WorkIndustry.css"
import IndustryCard from './IndustryCard'
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import {Autoplay} from "swiper/modules"

const industryData = [
  { img: "/images/icons/industry-icon-1.svg", 
    title: "Construction & Contracting" },
  {
    img: "/images/icons/industry-icon-2.svg",
    title: "Manufacturing",
  },
  { img: "/images/icons/industry-icon-3.svg", 
    title: "Professional Services" },
  {
    img: "/images/icons/industry-icon-4.svg",
    title: "Information Technology",
  },
  { 
    img: "/images/icons/industry-icon-5.svg", 
    title: "Wholesale & Distribution" },
  { 
    img: "/images/icons/industry-icon-6.svg", 
    title: "Finance, Insurance, and Real Estate" },
  { 
    img: "/images/icons/industry-icon-7.svg", 
    title: "Retail" },
  {
    img: "/images/icons/industry-icon-8.svg",
    title: "Services",
  },
  {
    img: "/images/icons/industry-icon-9.svg",
    title: "Government and Charitable",
  },
  { 
    img: "/images/icons/industry-icon-10.svg", 
    title: "Food and Beverage" },
  { 
    img: "/images/icons/industry-icon-11.svg",
     title: "Transportation, Freight & Logistics" },
  {
    img: "/images/icons/industry-icon-12.svg",
    title: "Miscellaneous",
  },
];


function WorkIndustry() {

    const handlePrevButtonClickInd = () => {
        const swiperInstance = document.querySelector('#ind-cards-slider').swiper;
        swiperInstance.slidePrev();
      };
      
      const handleNextButtonClickInd = () => {
        const swiperInstance = document.querySelector('#ind-cards-slider').swiper;
        swiperInstance.slideNext();
      };
  return (
    <div className='work-industry-container text-center standard-padding-space'>
        <div className='container my-3'>
        <h3 className='body-heading mb-3'>Industries We Serve</h3>
        {/* <h3 className='body-heading-b mx-auto'><span>Industries we work with</span></h3> */}
        <div className='industry-list container mt-5'>
            {/* <div className='row'>
                {industryData.map((ele)=>{
                    return <IndustryCard img={ele.img} title={ele.title} />
                })}
            </div> */}
            <Swiper
            spaceBetween={30}
            autoplay={{
              delay: 1500,
              disableOnInteraction: false,
            }}
            loop={true}
            modules={[Autoplay]}
            navigation={{
              nextEl: '.swiper-button-next-ind',
              prevEl: '.swiper-button-prev-ind',
            }}
            breakpoints={{
                200:{
                  slidesPerView: 1,
                },
                550: {
                  slidesPerView: 2,
                },
                800: {
                  slidesPerView: 3,
                },
                1200: {
                  slidesPerView: 4,
                },
                1400:{
                    slidesPerView:5,
                }
              }}
            pagination={{ clickable: true }}
            observer ={true}
            observeParents={true}
            parallax={true}
            className="ind-list pt-4"
            style={{position:"relative"}}
            id="ind-cards-slider"
            >
                  <div className="swiper-button-prev-ind" onClick={handlePrevButtonClickInd}>
                        <img alt="icon" loading="lazy" src="/images/icons/indus-carousel-arrow-left.png" className="arrow-img"/>
                    </div>
              {
                industryData.map((ele,ind)=>{
                  return(<>
                    <SwiperSlide key={ind}>
                      <IndustryCard
                        img={ele.img}
                        title={ele.title}
                      />
                    </SwiperSlide>
                     </>)
                })
              }
                    <div className="swiper-button-next-ind" onClick={handleNextButtonClickInd}>
                        <img alt="icon" loading="lazy" src="/images/icons/indus-carousel-arrow-right.png" className="arrow-img"/>
                    </div>
        </Swiper>
        
        </div>


        </div>
    </div>
  )
}

export default WorkIndustry